// TrainerHeroSection.jsx
import React from 'react';
import '../Stylings/TrainerHeroSection.css';  

const TrainerHeroSection = () => {
  return (
    <div className="trainer-hero">
      <h1>Start Your Fitness Journey with Our Trainers</h1>
      <p>Choose the perfect trainer for your needs and get started today!</p>
    </div>
  );
};

export default TrainerHeroSection;
